import Lookup from '..';
import { FilterOperations } from '@bimser/components/dist/BCExtremeGrid/entities';
import { DataGridCellType, IDataGridRow } from '../../DataGrid/entities';
import { MLHelper } from '@bimser/core';

export function filteringStaticForMobile(data: Lookup, rowValue: IDataGridRow) {
	const filterColumns = [];
	const filterRows = [];
	const columns = data.__getColumns();

	columns.map(item => {
		filterColumns.push({ ...item.filtering, name: item.name, editType: item.editType });
	});
	const filterColumnsValue = filterColumns.filter(i => i.value);

	function filterOperation(
		row: any,
		column: any,
		operation: FilterOperations,
		cellType: DataGridCellType
	) {
		switch (cellType) {
			case DataGridCellType.number: {
				switch (operation) {
					case 'contains':
						return row === column;
					case 'equal':
						return row === column;
					case 'notEqual':
						return row !== column;
					case 'greaterThan':
						return row > column;
					case 'graterThenOrEqual':
						return row >= column;
					case 'lessThan':
						return row < column;
					case 'lessThanOrEqual':
						return row <= column;
				}
				break;
			}
			case DataGridCellType.numberBox: {
				switch (operation) {
					case 'contains':
						return row === column;
					case 'equal':
						return row === column;
					case 'notEqual':
						return row !== column;
					case 'greaterThan':
						return row > column;
					case 'graterThenOrEqual':
						return row >= column;
					case 'lessThan':
						return row < column;
					case 'lessThanOrEqual':
						return row <= column;
				}
				break;
			}
			case DataGridCellType.boolean: {
				switch (operation) {
					case 'equal':
						return row === column;
					case 'notEqual':
						return row !== column;
				}
				break;
			}
			case DataGridCellType.text:
			case DataGridCellType.select: {
				switch (operation) {
					case 'contains':
						return row?.toLocaleLowerCase().includes(column.toLocaleLowerCase());
					case 'notContains':
						return !row?.toLocaleLowerCase().includes(column.toLocaleLowerCase());
					case 'startsWith':
						return row?.toLocaleLowerCase().startsWith(column.toLocaleLowerCase());
					case 'endsWith':
						return row?.toLocaleLowerCase().endsWith(column.toLocaleLowerCase());
					case 'equal':
						return row === column;
					case 'notEqual':
						return row !== column;
				}
			}
			case DataGridCellType.multiLanguage:
			case DataGridCellType.multiLanguageTextBox: {
				const mlRow = MLHelper.getMLText(row).toLocaleLowerCase();

				switch (operation) {
					case 'contains':
						return mlRow.includes(column.toLocaleLowerCase());
					case 'notContains':
						return !mlRow.includes(column.toLocaleLowerCase());
					case 'startsWith':
						return mlRow.startsWith(column.toLocaleLowerCase());
					case 'endsWith':
						return mlRow.endsWith(column.toLocaleLowerCase());
					case 'equal':
						return mlRow === column.toLocaleLowerCase();
					case 'notEqual':
						return mlRow !== column.toLocaleLowerCase();
				}
			}
			case DataGridCellType.actionButton:
				break;
			case DataGridCellType.timePicker:
			case DataGridCellType.dateRangePicker:
			case DataGridCellType.dateTimePicker:
			case DataGridCellType.datePicker: {
				const dateColumn = new Date(column);
				const dateRow = new Date(row);
				switch (operation) {
					case 'greaterThan':
						return dateRow > dateColumn;
					case 'graterThenOrEqual':
						return dateRow >= dateColumn;
					case 'lessThan':
						return dateRow < dateColumn;
					case 'lessThanOrEqual':
						return dateRow <= dateColumn;
				}
				break;
			}
			default: {
				switch (operation) {
					case 'contains':
						return row?.toLocaleLowerCase().includes(column.toLocaleLowerCase());
					case 'notContains':
						return !row?.toLocaleLowerCase().includes(column.toLocaleLowerCase());
					case 'startsWith':
						return row?.toLocaleLowerCase().startsWith(column.toLocaleLowerCase());
					case 'endsWith':
						return row?.toLocaleLowerCase().endsWith(column.toLocaleLowerCase());
					case 'equal':
						return row === column;
					case 'notEqual':
						return row !== column;
					case 'greaterThan':
						return row > column;
					case 'graterThenOrEqual':
						return row >= column;
					case 'lessThan':
						return row < column;
					case 'lessThanOrEqual':
						return row <= column;
				}
			}
		}
	}

	filterColumnsValue.map(column => {
		const filterType = column.editType === 'number' || column.editType === 'numberBox';
		const columnValue = filterType ? parseInt(column.value) : column.value;
		filterRows.push(row =>
			filterOperation(
				row.cells.find(item => item.name == column.name).value,
				columnValue,
				column.operation,
				column.editType
			)
		);
	});

	const result = filterRows.filter(fn => fn(rowValue));

	return filterRows.length ? result.length > 0 : true;
}
